import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Notification } from 'base-ui'

import { useForgotPasswordPageContext } from '../context/ForgotPasswordPageContextProvider'

export const ForgotPasswordRequestNotification: FC = () => {
  const {
    email,
    isForgotPasswordFormSubmitted,
    isForgotPasswordRequestSuccess,
  } = useForgotPasswordPageContext()

  if (!isForgotPasswordFormSubmitted) {
    return null
  }

  const severity: 'error' | 'success' = isForgotPasswordRequestSuccess
    ? 'success'
    : 'error'

  const message = isForgotPasswordRequestSuccess ? (
    <FormattedMessage
      id="forgotpassword.email.send.notification.message"
      values={{ email }}
    />
  ) : (
    <FormattedMessage id="general.error" />
  )

  return (
    <Notification
      className="mt-3 w-full desktop-lg:container tablet:w-3/5"
      data-qa-id={`forgotPassword-form-notification-${severity}`}
      severity={severity}
    >
      {message}
    </Notification>
  )
}
